import React, { Fragment, useContext } from 'react';
import { Image } from '../../../AbstractElements';
import {AlignLeft, AlignJustify } from 'react-feather';
import CustomizerContext from '../../../Common/_helper/Customizer';
import { Link } from 'react-router-dom';
import appLogo from '../../../assets/images/logo/app-logo@3x1.png'

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar,toggleIcon } = useContext(CustomizerContext);
  const userType = sessionStorage.getItem('userType');
  return (
    <Fragment>
      <div className="logo-wrapper" onClick={() => toggleSidebar(!toggleIcon)}>
        {/* {mixLayout?
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default/`}>
            <Image attrImage={{ className: "img-fluid for-light", src: `${require("../../assets/images/logo/logo.png")}`, alt: "" }} />
          </Link>
          :
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default/`}>
            <Image attrImage={{ className: "img-fluid for-dark", src: `${require("../../assets/images/logo/logo-dark.png")}`, alt: "" }} />
          </Link>
        } */}
        {
          userType === 'admin' ? 
          <Link to={`${process.env.PUBLIC_URL}/admin/dashboard`}>
            <Image attrImage={{ className: "img-fluid for-light", src: appLogo, alt: "" }} />
          </Link>
          :
          <></>
          // <Link>
          //   <Image attrImage={{ className: "img-fluid for-light", src: appLogo, alt: "" }} />
          // </Link>
        }
        <div className="toggle-sidebar" >
          <AlignJustify className={`status_toggle middle`} id="sidebar-toggle"/>
        </div>
      </div> 
    </Fragment >   
  );
};

export default SidebarLogo;